export default "__VITE_ASSET__P1CaG$6s__"